<template>
  <!-- Left div because b-navbar does not trigger on mouseenter / mouseleave events -->
  <div class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-blue"
    @mouseenter="$sidebar.onMouseEnter()" @mouseleave="$sidebar.onMouseLeave()" :data="backgroundColor"
    v-if="!hideSidebar">
    <div class="scrollbar-inner" ref="sidebarScrollArea">
      <div class="sidenav-header align-items-center">
        <div class="ml-0">
          <!-- Sidenav toggler -->
          <div class="sidenav-toggler d-none d-xl-block" :class="{ active: !$sidebar.isMinimized }"
            @click="minimizeSidebar">
            <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
      <div class="navbar-inner">
        <button
          type="button"
          class="sidenav-user sidenav-user--clickable"
          title="Notificações"
          aria-label="Notificações"
          @click="$emit('open-notifications')"
        >
          <span class="sidenav-user-avatar-wrap">
            <span class="sidenav-user-avatar" aria-hidden="true">
              {{ userInitials }}
              <span
                v-if="unreadBadge"
                class="sidenav-user-unread-badge"
              >{{ unreadBadge }}</span>
            </span>
          </span>
          <span class="sidenav-user-name nav-link-text">{{ userName }}</span>
        </button>
        <b-navbar-nav>
          <slot name="links">
            <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
              <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
              </sidebar-item>
            </sidebar-item>
          </slot>
        </b-navbar-nav>
        <slot name="links-after"></slot>

        <b-navbar-nav class="navbar-logo text-center">
          <img src="img/janoo-icon-high-white.png" style="max-width: 24px; height: auto;" />
        </b-navbar-nav>

      <b-navbar-brand class="navbar-brand-img text-center">
          <img src="img/janoo-logo-v2-high-white.png" style="max-width: 180px; height: auto; padding-top: 10px; padding-bottom: 5px;" />
        </b-navbar-brand>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: "sideBar",
  data: () => {
    return {
      hideSidebar: false,
      sideBarLogo: require('@/assets/img/b-logo.png')
    }
  },
  props: {
    title: {
      type: String,
      default: "Creative Tim",
      description: "Sidebar title"
    },
    shortTitle: {
      type: String,
      default: "CT",
      description: "Sidebar short title"
    },
    backgroundColor: {
      type: String,
      default: "vue",
      validator: value => {
        let acceptedValues = [
          "",
          "vue",
          "blue",
          "green",
          "orange",
          "red",
          "primary"
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar background color (vue|blue|green|orange|red|primary)"
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item"
    },
    unreadCount: {
      type: Number,
      default: 0,
      description: "Unread push-inbox count shown as badge on the user avatar"
    }
  },
  computed: {
    ...mapGetters('auth', {
      user: 'user',
    }),

    userName() {
      return (this.user && this.user.name) || ''
    },

    userInitials() {
      const parts = this.userName
        .trim()
        .split(/\s+/)
        .filter(Boolean)
      if (!parts.length) return '?'
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
    },

    unreadBadge() {
      const n = Number(this.unreadCount) || 0
      if (n <= 0) return ''
      return n > 99 ? '99+' : String(n)
    },
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  created() {
    if (window.location.href.indexOf('janoo.com.br') > 0) {
      // this.hideSidebar = true
      this.sideBarLogo = require('@/assets/img/j-logo.png')
    }
  },
  mounted() {
    // this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;
    this.minimizeSidebar();
  },
  beforeUnmount() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>

<style scoped>
.sidenav-user--clickable {
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  width: calc(100% + 2rem);
}

.sidenav-user-avatar {
  position: relative;
}

.sidenav-user-unread-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 1rem;
  height: 1rem;
  padding: 0 4px;
  border-radius: 999px;
  background: #f5365c;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1rem;
  text-align: center;
  pointer-events: none;
  z-index: 1;
}
</style>
